import { createContext, useState } from "react";
import { ResumeHook, useResume } from "../hooks/getResume";
import { usePeriodContext } from "@/hooks/usePeriodContext";
import { useFilters, IUserFilters } from "../hooks/filters";
import { IUseOrders, useOrders } from "../hooks/orders";
import TableItensHeaders from "../settings/TableItensHeaders";
import { TItensOrders, useItensOrders } from "../hooks/itensOrders";
import { IQueryPaginationResponse } from "@/services/adapterPaginations";
import { useNavigate } from "react-router-dom";

interface AuditOrdersContextProps {
    resume: ResumeHook | undefined
    order: IUseOrders | undefined
    filters: IUserFilters | undefined
    period: [string, string] | []
    onClear: VoidFunction
    itens: IQueryPaginationResponse<TItensOrders> | undefined
    headers: any
    setHeaderItens: any
    onSelectItemDetails: ((item: TItensOrders) => void) | undefined
}

export const AuditOrdersContext = createContext<AuditOrdersContextProps>({
    resume: undefined,
    onClear: () => { },
    order: undefined,
    filters: undefined,
    headers: [],
    period: [],
    setHeaderItens: undefined,
    itens: undefined,
    onSelectItemDetails: () => {}
})


const AuditOrdersProvider = ({ children }: { children: any }) => {
    const nav = useNavigate();
    const [headersItens, setHeaderItens] = useState(TableItensHeaders)
    const [hasFiltered, setHasFiltered] = useState(false)

    const {
        period: [start, end],
        setPeriod
    } = usePeriodContext()

    const handleSetPeriod = (newPeriod: [string, string]) => {
        setHasFiltered(true)
        setPeriod(newPeriod)
    }

    const filters = useFilters()

    const resume = useResume({
        body: {
            dataFim: end?.replaceAll?.('-', '/'),
            dataInicio: start?.replaceAll?.('-', '/'),
            codigoPedido: filters?.codeOrder,
            situacao: filters?.status,
            produto: filters?.codeOrNameProd
        },
        enabled: hasFiltered
    })

    const order = useOrders({
        body: {
            dataFim: end?.replaceAll?.('-', '/'),
            dataInicio: start?.replaceAll?.('-', '/'),
            codigoPedido: filters?.codeOrder,
            situacao: filters?.status,
            produto: filters?.codeOrNameProd
        },
        enabled: hasFiltered
    })

    const itens = useItensOrders({
        dependency: {
            idAuditoria: order?.orderSelected?.idAuditoria as number
        }
    })

    function onSelectItemDetails(item: TItensOrders) {
        nav(+item?.idProduto+'/itens')
    }

    function onClear() {

    }

    return (
        <AuditOrdersContext.Provider value={{
            resume,
            onClear,
            order,
            onSelectItemDetails,
            period: [start, end],
            filters: {
                ...filters,
                //@ts-ignore
                setPeriod: handleSetPeriod
            },
            headers: headersItens,
            setHeaderItens: setHeaderItens,
            itens
        }}>
            {children}
        </AuditOrdersContext.Provider>
    )
}

export default AuditOrdersProvider;